import React from 'react'
import { pushToDataLayer } from 'lib/tracking'
import Image from 'next/image'

import useRouter from 'hooks/useRouter'

import chatIcon from './chat-icon.svg'

import styles from './BusinessPageHelp.module.css'

const BusinessPageHelp: React.FC = () => {
  const router = useRouter()

  return (
    <div className={styles.container} data-cy="BusinessPageHelp">
      <div className={styles.stickyContainer}>
        <div
          role="button"
          tabIndex={0}
          onClick={() => {
            pushToDataLayer({
              event: 'businessPageHelpContactClick',
            })
            router.push('/page/business-form')
          }}
          className={styles.roundedButton}
        >
          <Image src={chatIcon} width={33} height={30} alt="Chat" />
        </div>
      </div>
    </div>
  )
}

export default BusinessPageHelp
